import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ObjectionSuggestionReportService } from './objection-suggestion-report.service';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { MatDialog } from '@angular/material/dialog';
import { Board, Departments, ObjSuggestionType } from '../../interface/common-interface';
import { ProjectConstants } from '../../project-constants';
import { CommonFunction } from '../../common-function';

export class ObjectionSuggestionList {
  Id: any;
  BoardName: any;
  Department: any;
  ObjectionSuggstionType: string;
  Objection_Suggstion: any
  Subject: any
  objectionSuggestion: any;
  CreatedOn: any;
  statusName: any;
  UserName: any
  UserMobileNo: any
  UserEmail: any
  UserPan: any
  UserType: any
  Details: any
  assignedToName: any;
  updatedOn: string;
}

const COLS = [
  { value: "OBJECTION/SUGGESTION ID", lowercaseValue: "Id", displayName: "Id" },
  { value: "BOARD", lowercaseValue: "BoardName", displayName: "Board" },
  { value: "DEPARTMENT", lowercaseValue: "Department", displayName: "Department" },
  { value: "CREATED DATE", lowercaseValue: "CreatedOn", displayName: "Created Date" },
  { value: "Objection/Suggestion TYPE", lowercaseValue: "ObjectionSuggstionType", displayName: "Objection/Suggestion Type" },
  { value: "SUBJECT", lowercaseValue: "Subject", displayName: "Subject" },
  { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
];
@Component({
  selector: 'app-objection-suggestion-report',
  templateUrl: './objection-suggestion-report.component.html',
  styleUrls: ['./objection-suggestion-report.component.scss'],
})
export class ObjectionSuggestionReportComponent implements OnInit {
  displayedCols = COLS;
  serachCtrl: FormControl = new FormControl();
  allCols = COLS;
  displayedColumns: any[];
  userLists: any = [];
  // grievanceList: GrievanceList[] = [];
  filterOptions: any[] = [];
  selectedFilterOption: any = null;
  phoneNumberVisible: boolean = false;
  emailVisible: boolean = false;
  phoneNo: any;
  emaild: any;
  objectionNoData = ProjectConstants.objectionNotAvailable
  isShowTable: boolean = false;
  dataSource = new MatTableDataSource(this.userLists);
  objectionSuggestionList: ObjectionSuggestionList[] = [];
  loading: boolean;
  noDataFoundEr: boolean = false
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }
  protected _onDestroy = new Subject<void>();

  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);

  protected ObjectionSuggestions: ObjSuggestionType[] = [];
  public objSuggCtrl: FormControl = new FormControl();
  public objSuggFilterCtrl: FormControl = new FormControl();
  public filteredObjSugg: ReplaySubject<ObjSuggestionType[]> = new ReplaySubject<ObjSuggestionType[]>(1);

  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);
  progressSpinnerDialog: any = null;
  isSubmitDisabled: boolean = false
  showError: boolean = false
  showFormEr: boolean = false
  firstFormGroup = this._formBuilder.group({
    osTypeCtrl: [0],
    departmentCtrl: [0],
    boardCtrl: [0, [Validators.required]],
    reportCtrl: ['All'],
    fromCtrl: ['', [Validators.required]],
    toCtrl: ['', [Validators.required]],
    // radioCtrl: ['WithoutAuditTrail', [Validators.required]],
  })

  reportTypes: any = []
  constructor(public objsuggestionSerice: ObjectionSuggestionReportService,
    private commonFunction: CommonFunction,
    public _formBuilder: FormBuilder,
    public dialog: MatDialog,
    public datepipe: DatePipe) { }

  async ngOnInit() {

    // this.searchReport()

    this.reportTypes = [
      { 'value': "All" },
      { 'value': "Objection" },
      { 'value': "Suggestion" },
    ]
    this.displayedCols = [
      { value: "OBJECTION/SUGGESTION ID", lowercaseValue: "Id", displayName: "Id" },
      { value: "BOARD", lowercaseValue: "BoardName", displayName: "Board" },
      { value: "DEPARTMENT", lowercaseValue: "Department", displayName: "Department" },
      { value: "CREATED DATE", lowercaseValue: "CreatedOn", displayName: "Created Date" },
      { value: "Objection/Suggestion TYPE", lowercaseValue: "ObjectionSuggstionType", displayName: "Objection/Suggestion Type" },
      { value: "SUBJECT", lowercaseValue: "Subject", displayName: "Subject" },
      { value: "STATUS", lowercaseValue: "statusName", displayName: "Status" },
    ];

    //call to load board
    this.displayProgressSpinner();
    const response: any = await this.objsuggestionSerice.loadBoard();
    if (response != null && !response.error) {
      this.progressSpinnerDialog.close()
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.boards = response
        //set boards in array  
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards.slice());
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
        //
      } else if (response[0].status == ProjectConstants.responseStatusFailure) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
    }
    //
  }


  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(
      this.boards.filter(board => board.boardName.toLowerCase().indexOf(search) > -1)
    );
  }
  //


  // select board dependant on grievance type
  async selectBoard(boards: any) {
    if (boards != 0) {
      this.displayProgressSpinner();
      const response: any = await this.objsuggestionSerice.loadDepartments(boards);
      if (response != null && !response.error) {
        this.progressSpinnerDialog.close()
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          this.departments = response;
          this.departmentCtrl.setValue(this.departments[10]);
          this.filteredDepartment.next(this.departments.slice());
          this.departmentFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filtereDepartments();
            })
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    }
  }
  //

  protected filtereOs() {
    if (!this.ObjectionSuggestions) {
      return;
    }
    let search = this.objSuggFilterCtrl.value;
    if (!search) {
      this.filteredObjSugg.next(this.ObjectionSuggestions.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredObjSugg.next(
      this.ObjectionSuggestions.filter(department => department.objectionSuggestion.toLowerCase().indexOf(search) > -1)
    );
  }


  //department type filter
  protected filtereDepartments() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(department => department.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }
  //



  async selectReportType(reportVal: any) {
    if (reportVal != null) {
      this.displayProgressSpinner();
      const data = {
        'depId': this.firstFormGroup.controls['departmentCtrl'].value,
        'osType': reportVal
      }
      const response: any = await this.objsuggestionSerice.loadObjectioSuggestions(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if (response.length != 0) {
          if (response[0].status == ProjectConstants.responseStatusSuccess) {
            this.ObjectionSuggestions = response;
            this.objSuggCtrl.setValue(this.ObjectionSuggestions[10]);
            this.filteredObjSugg.next(this.ObjectionSuggestions.slice());
            this.objSuggFilterCtrl.valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filtereOs();
              })
          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
          }
        } else {
          this.ObjectionSuggestions = []
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    }
  }

  onDownloadClick() {
    var title;
    // if(this.firstFormGroup.controls['reportCtrl'].value=="All"){
    //   title = 'Objection and Suggestion Report';
    // }else if(this.firstFormGroup.controls['reportCtrl'].value=="Objection"){
    //   title = 'Objection Report';
    // }else{
    //   title = 'Suggestion Report';
    // }
    const header = ["Id", "Created Date", "Username", "Mobile No.", "Email", "Pan No.", "Type of user", "Board", "Department", "Objection/Suggestion", "Objection/Suggestion Type", "Subject", "Description", "Status", "Assigned To Name", "Last Updated Date"]
    let workbook = new Workbook();
    let worksheet;
    if (this.firstFormGroup.controls['reportCtrl'].value == "All") {
      title = 'Objection and Suggestion Report';
      worksheet = workbook.addWorksheet('Objection and Suggestion Report')
    } else if (this.firstFormGroup.controls['reportCtrl'].value == "Objection") {
      title = 'Objection Report';
      worksheet = workbook.addWorksheet('Objection Report')
    } else {
      title = 'Suggestion Report';
      worksheet = workbook.addWorksheet('Suggestion Report')
    }
    let titleRow = worksheet.addRow([title]);
    titleRow.font = {
      name: 'Times New Roman',
      size: 16,
      underline: 'single',
      bold: true,
    }

    worksheet.mergeCells('A1:O1');
    worksheet.addRow([]);
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '808080' },
      }
      cell.font = {
        name: 'Arial',
        family: 2,
        bold: true,
        size: 10,
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      }
    });
    const list = []

    this.objectionSuggestionList.forEach((row: any) => {
      list.push(Object.values(row))
    })

    list.forEach(d => {
      let row = worksheet.addRow(d);
    });

    for (var i = 1; i <= header.length; i++) {
      const dobCol = worksheet.getColumn(i);
      dobCol.eachCell({ includeEmpty: false }, function (cell, rowNumber) {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }
      });
      if (i == 3) {
        worksheet.getColumn(i).width = 30;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      } else if (i == 11 || i == 12) {
        worksheet.getColumn(i).width = 50;
        worksheet.getColumn(i).alignment = { vertical: 'justify', horizontal: 'left', wrapText: true }
      } else if (i == 5) {
        worksheet.getColumn(i).width = 40;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      } else if (i == 9 || i == 10) {
        worksheet.getColumn(i).width = 30;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      }
      else {
        worksheet.getColumn(i).width = 20;
        worksheet.getColumn(i).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      }
    }
    titleRow.border =
    {
      top: { style: 'thin', color: { argb: 'FFFFFF' } },
      left: { style: 'thin', color: { argb: 'FFFFFF' } },
      bottom: { style: 'thin', color: { argb: 'FFFFFF' } },
      right: { style: 'thin', color: { argb: 'FFFFFF' } }
    }
    headerRow.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
    headerRow.height = 35;
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, title + '.xlsx');
    });
  }



  formDateChanged() {
    if (this.firstFormGroup.controls['toCtrl'].value != '') {
      this.firstFormGroup.patchValue({
        toCtrl: ""
      });

    }
  }
  valueChanged() {
    this.showFormEr = false
    if (this.firstFormGroup.controls['fromCtrl'].value == '') {
      this.showFormEr = true
    }
    var date = this.calculateDiff(this.firstFormGroup.controls['fromCtrl'].value, this.firstFormGroup.controls['toCtrl'].value)
    this.showError = false
    if (date < -1) {
      this.showError = true
    }
  }

  calculateDiff(current, dateSent) {
    let currentDate = new Date(dateSent);
    dateSent = new Date(current);
    return Math.floor((Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())) / (1000 * 60 * 60 * 24));
  }


  async submitForm() {
    if (this.firstFormGroup.valid && !this.showError) {
      this.objectionSuggestionList = []
      this.dataSource.data = this.objectionSuggestionList;
      const fromDate = this.datepipe.transform(this.firstFormGroup.controls['fromCtrl'].value, 'yyyy-MM-dd');
      const toDate = this.datepipe.transform(this.firstFormGroup.controls['toCtrl'].value, 'yyyy-MM-dd');
      var osType = null
      if (this.firstFormGroup.controls['osTypeCtrl'].value != 0) {
        osType = this.firstFormGroup.controls['osTypeCtrl'].value
      }
      var depId = null
      if (this.firstFormGroup.controls['departmentCtrl'].value != 0) {
        depId = this.firstFormGroup.controls['departmentCtrl'].value
      }
      var boardId = null
      if (this.firstFormGroup.controls['boardCtrl'].value != 0) {
        boardId = this.firstFormGroup.controls['boardCtrl'].value
      }
      const data = {
        'fkOsId': osType,
        'fkDepid': depId,
        'fkBdid': boardId,
        fromDate: fromDate,
        toDate: toDate,
        // 'reportType': this.firstFormGroup.controls['reportCtrl'].value
        // radioCtrl:this.firstFormGroup.controls['radioCtrl'].value,
      }
      this.displayProgressSpinner();
      this.noDataFoundEr = false
      const response1: any = await this.objsuggestionSerice.loadForOSReport(data)
      if (response1 != null && !response1.error) {
        this.noDataFoundEr = true
        this.progressSpinnerDialog.close()

        if (response1.length != 0) {
          if (response1[0].status == ProjectConstants.responseStatusSuccess) {
            this.objectionSuggestionList = []
            for (var i = 0; i < response1.length; i++) {
              // var created_date = response1[i].createdOn
              var created_date = (response1[i].createdOn != null && response1[i].createdOn.includes("+")) ? response1[i].createdOn.split("+")[0] : response1[i].createdOn

              let created_on = this.datepipe.transform(created_date, 'dd/MM/yyyy hh:mm a');
              const customObj = new ObjectionSuggestionList();
              customObj.Id = response1[i].pkOsid
              customObj.CreatedOn = created_on
              customObj.UserName = response1[i].userName
              customObj.UserMobileNo = response1[i].userMobileNo
              customObj.UserEmail = response1[i].userEmail
              customObj.UserPan = response1[i].userPanNo

              if (response1[i].osUserType == "MU") {
                customObj.UserType = ProjectConstants.userTypeMhadaUser
              } else if (response1[i].osUserType == "LU") {
                customObj.UserType = ProjectConstants.userTypeLotteryUser
              }
              customObj.BoardName = response1[i].boardName
              customObj.Department = response1[i].departmentName
              customObj.ObjectionSuggstionType = response1[i].uosType,
                customObj.Objection_Suggstion = response1[i].osTypeName,
                customObj.Subject = response1[i].osSubject,
                customObj.Details = response1[i].osDetails
              customObj.statusName = response1[i].statusName
              customObj.assignedToName = response1[i].assigeToName
              // var updated_date = response1[i].updatedOn
              var updated_date = (response1[i].updatedOn != null && response1[i].updatedOn.includes("+")) ? response1[i].updatedOn.split("+")[0] : response1[i].updatedOn 
              customObj.updatedOn = this.datepipe.transform(updated_date, 'dd/MM/yyyy hh:mm a');
              this.objectionSuggestionList.push(customObj)
            }
            this.dataSource.data = this.objectionSuggestionList;

          } else {
            await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
          }
        } else {
          this.objectionSuggestionList = []
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      }
    } else {
      this.isSubmitDisabled = false
    }
    this.displayedColumns = this.displayedCols.map((col) => col.value);
  }
}
